import axios from "axios";
import store from "@/store";
import { VueAxios } from "./axios";
import notification from "ant-design-vue/es/notification";
import { message } from "ant-design-vue";

// 创建 axios 实例
const service = axios.create({
  baseURL: "/zd-api/teacher-lib/",
  timeout: 15000 // 请求超时时间
});

const err = (error) => {
  if (error.response) {
    const data = error.response.data;
    const token = localStorage.getItem("token");
    if (error.response.status === 403) {
      notification.error({
        message: "Forbidden",
        description: data.message
      });
    }
    if (error.response.status === 401) {
      notification.error({
        message: "登录失效",
        description: "登录失效，请重新登录"
      });
      if (token) {
        store.dispatch("Logout").then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      }
    }
  }
  return Promise.reject(error);
};

service.interceptors.request.use((config) => {
  config.headers["token"] = localStorage.getItem("token"); // 让每个请求携带自定义 token 请根据实际情况自行修改
  config.headers["Content-Type"] = "application/json;charset=utf-8"; // 添加请求头
  return config;
}, err);

service.interceptors.response.use((response) => {
  if (response.data.status === 403 || response.data.status === 401) {
    const token = localStorage.getItem("token");
    notification.error({
      message: "登录失效",
      description: "登录失效，请重新登录"
    });
    if (token) {
      store.dispatch("Logout").then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
    }
  }
  if (response.data.status === 500) {
    message.error(response.data.msg);
  }
  if (response.data.status === 408) {
    message.error(response.data.msg);
  }
  return response.data;
}, err);

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service);
  }
};

export { installer as VueAxios, service as axios };
